import React, {useRef} from "react";
import {
    Autocomplete, Divider, Grid, TextField,
    Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Field, FieldProps, Formik, FormikProps} from "formik";
import {initialRubricItem, initialValues, ValidationSchema} from "./formik";
import {RubricItem, NewPlanRubricForm} from "../../../../../types/newPlanItem";
import {DictionaryObject} from "../../../../../types/dictionary";
import {ProductType} from "../../../../../utils/enums";
import {useDictionary} from "../../../../../utils/useDictionary";
import {ProductModal, RubricItem as RubricItemComponent} from "./components";

export type ProductTypeBundle = {
    dictionary: DictionaryObject[];
    selected: DictionaryObject;
    onSelectChange: (
        e: React.SyntheticEvent<Element, Event>,
        newValue: DictionaryObject | null
    ) => void;
}

export const RubricFields = ({
                                 formikRef, editingInitialState, disabled = false,
                             }: {
    formikRef: React.RefObject<FormikProps<NewPlanRubricForm>>;
    editingInitialState?: NewPlanRubricForm,
    disabled?: boolean,
}) => {
    const onSubmit = (values: NewPlanRubricForm) => {
    };
    const {t} = useTranslation();

    const productType = useDictionary(
        ProductType,
        (type) => ({value: type, label: t(`product_type.${type}`)}),
        editingInitialState
            ? editingInitialState.productType
            : {value: ProductType.product, label: t("product_type.product")}
    );

    const [isProductModalOpen, setIsProductModalOpen] = React.useState(false);
    const [currentModalIdx, setCurrentModalIdx] = React.useState(0);
    const onProductModalOpen = () => {
        setCurrentModalIdx(0);
        setIsProductModalOpen(true);
    };
    const onProductModalClose = () => {
        setIsProductModalOpen(false);
        // formikRef!.current!.setTouched({
        //     item: {
        //         productCode: true,
        //         productName: true,
        //         productBrief: true
        //     }
        // });
    }

    const productBundle = {
        isOpen: isProductModalOpen,
        onClose: onProductModalClose,
        currentModalIdx
    };

    const renderCount = useRef(0);

    React.useEffect(() => {

        if (!editingInitialState || renderCount.current >= 1) {
            formikRef.current?.setFieldValue("item", initialRubricItem);
        }
        formikRef.current?.setFieldValue("productType", productType.selected, false);

        renderCount.current += 1;
    }, [productType.selected]);

    return (
        <Formik innerRef={formikRef}
                initialValues={editingInitialState || initialValues}
                validationSchema={ValidationSchema()}
                onSubmit={onSubmit}
                validateOnMount
        >
            {(frops: FormikProps<NewPlanRubricForm>) => (
                <React.Fragment>
                    <Grid container columnSpacing={3} rowSpacing={1}>
                        <Grid item xs={12} sx={{mb: 1}}>
                            <Typography variant="h6">
                                {t("cabinet.new_plan_item.sections.rubric")}
                            </Typography>
                        </Grid>

                        <Grid item container columnSpacing={3} rowSpacing={1}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Autocomplete
                                    disablePortal size="small"
                                    options={productType.dictionary}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    value={productType.selected}
                                    onChange={productType.onSelectChange}
                                    renderInput={params =>
                                        <Field name={"productType"}>
                                            {({field, form, meta}: FieldProps) => (
                                                <TextField {...params} fullWidth color="primary"
                                                           label={t("auction.dictionary.productType")}
                                                           error={!!(meta.touched && meta.error)}
                                                           helperText={meta.touched && meta.error}
                                                           disabled={disabled}
                                                />
                                            )}
                                        </Field>
                                    }
                                />
                            </Grid>
                            <Grid item sx={{alignSelf: "center"}}>
                                <Typography fontSize={12}>
                                    {t("cabinet.new_plan_item.rubric.reset_warning")}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{mt: 3, mb: 1, ml: "auto", mr: "auto", width: '85%'}}/>

                        <Grid item>
                            <ProductModal
                                setFieldValue={frops.setFieldValue}
                                productBundle={productBundle}
                                productType={frops.values.productType}
                                item={frops.values.item}
                            />


                            <React.Fragment>
                                <RubricItemComponent
                                    frops={frops}
                                    onProductModalOpen={onProductModalOpen}
                                    disabled={disabled}
                                />

                            </React.Fragment>

                        </Grid>
                    </Grid>
                </React.Fragment>
            )}
        </Formik>
    )
}